import * as React from 'react'
import { CirclePlay } from 'lucide-react'
import { useVideo } from '@/hooks/useVideos'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'

/**
 * Watch the directory's explanation of this kind of problem.
 *
 * The one place the clip is genuinely worth its bandwidth: somebody standing
 * under a tree deciding whether what they are looking at IS mistletoe, or over
 * a valve box deciding whether that is flow-by. Behind a tap rather than
 * inline, because a survey runs on cell data and nobody needs the video once
 * they know the answer. Shared by both survey screens.
 */
export function ProblemExplainer({ videoId }: { videoId: string }) {
  const [open, setOpen] = React.useState(false)
  const video = useVideo(open ? videoId : null)

  return (
    <>
      <button
        type="button"
        onClick={() => {
          setOpen(true)
        }}
        className="flex items-center gap-1 text-xs font-medium text-brand hover:underline"
      >
        <CirclePlay className="h-3.5 w-3.5" />
        What does this look like?
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl p-0">
          <DialogTitle className="sr-only">What this problem looks like</DialogTitle>
          {video.data?.playbackUrl == null ? (
            <p className="p-6 text-center text-sm text-muted-text">
              {video.isPending ? 'Loading…' : 'This clip cannot be played yet.'}
            </p>
          ) : (
            <iframe
              src={video.data.playbackUrl}
              title="What this problem looks like"
              allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
              allowFullScreen
              className="aspect-video w-full rounded-lg border-0"
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}
